import { createFileRoute } from '@tanstack/react-router';
import MatchingPage from '@/pages/matching/matching-page';

export const Route = createFileRoute('/_protected/matching/')({
  component: MatchingPage,
});
